/**
 * @generated SignedSource<<50b96e3947c1f872cadec3f1a2c58a1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SharePointPeoplePickerInput = {
  allUrlZones?: boolean | null | undefined;
  allowEmailAddresses?: boolean | null | undefined;
  allowMultipleEntities?: boolean | null | undefined;
  maximumEntitySuggestions?: number | null | undefined;
  principalSource?: number | null | undefined;
  principalType?: number | null | undefined;
  queryString: string;
  siteUrl: string;
};
export type PeoplePickerQuery$variables = {
  input: SharePointPeoplePickerInput;
};
export type PeoplePickerQuery$data = {
  readonly getSharePointSiteMembers: ReadonlyArray<{
    readonly email: string | null | undefined;
    readonly loginName: string | null | undefined;
    readonly memberId: string;
    readonly name: string | null | undefined;
  } | null | undefined> | null | undefined;
};
export type PeoplePickerQuery = {
  response: PeoplePickerQuery$data;
  variables: PeoplePickerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SharePointPeoplePicker",
    "kind": "LinkedField",
    "name": "getSharePointSiteMembers",
    "plural": true,
    "selections": [
      {
        "alias": "memberId",
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": "name",
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "loginName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PeoplePickerQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PeoplePickerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "950972ed6bafbb8b423e221c88cdda09",
    "id": null,
    "metadata": {},
    "name": "PeoplePickerQuery",
    "operationKind": "query",
    "text": "query PeoplePickerQuery(\n  $input: SharePointPeoplePickerInput!\n) {\n  getSharePointSiteMembers(input: $input) {\n    memberId: id\n    name: title\n    email\n    loginName\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ef80ca95e4486781ad9605fa4218e96";

export default node;
